module.exports = __webpack_public_path__ + "img/icon_work_06.1a81d5b3.png";